import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ErrorExtractorService {
    extractError(error: any): Error | string {
        if (error instanceof Error || typeof error === 'string') {
            return error;
        }

        if (error instanceof HttpErrorResponse) {
            if (error.error instanceof HttpErrorResponse) {
                return this.extractError(error.error);
            }

            if (error.error instanceof Error) {
                return error.error;
            }

            if (error.error instanceof ErrorEvent) {
                return error.error.message;
            }

            if (typeof error.error === 'string') {
                return error.error;
            }

            return error.message;
        }

        if (error.error) {
            return this.extractError(error.error);
        }

        if (error.originalError) {
            return this.extractError(error.originalError);
        }

        if (error.message) {
            return this.extractError(error.message);
        }

        return new Error('Uknown Error Type.');
    }
}
